export default "__VITE_ASSET__CO6i7UOn__"